<script setup lang="ts">
import type { ParsedFilterData } from '@autobid/strapi-integration/server/trpc/routers/auctions/auctionsFilter'
import type { SelectOptions } from '@autobid/ui/types/components/Select'
import type { Ref } from 'vue'
import { useAuctionStore } from '@autobid/nuxt-pinia-store/store/useAuctionStore'
import Select from '@autobid/ui/components/elements/select/Select.vue'
import SelectContainer from '@autobid/ui/components/elements/select/SelectContainer.vue'
import { storeToRefs } from 'pinia'

const auctionStoreKey = inject('auctionStoreKey')
const { filter } = storeToRefs(useAuctionStore(String(auctionStoreKey)))

const filterData = inject('filterData') as Ref<ParsedFilterData>

const onChange = (v: SelectOptions | undefined) => (filter.value.descriptionTitles = v ? v.map(String) : [])
</script>

<template>
  <SelectContainer class="mt-4">
    <Select
      :value="filter.descriptionTitles"
      :options="filterData.descriptions"
      :placeholder="$t('please-insert-a-value-or-click-in-the-arrow')"
      input-id="descriptionTitles"
      multiple
      full-length-display-value
      @change="onChange"
    />
  </SelectContainer>
</template>
